import React, { Children, useState } from "react";
import { Formik, Form } from "formik";
import { Button, Grid } from "@mui/material";
import HeaderStepper from "./HeaderStepper";
import StepButton from "../../buttons/StepButton";
import FormFooter from "./FormFooter";
import useLocales from "../../../hooks/useLocales";
import IsSubmittingButton from "../../buttons/IsSubmittingButton";
import { useAppDispatch } from "../../../app/hooks";
import { ApiSlice } from "../../../features/api/Api";
import Swal from "sweetalert2";

interface StepperProps {
  children: React.ReactNode;
  initialValues: any;
  onSubmit: Function;
}

const Stepper = ({ children, initialValues, onSubmit }: StepperProps) => {
  const { translate } = useLocales();
  const childrenArray = Children.toArray(children);
  const [step, setStep] = useState<number>(0);
  const currentChild = childrenArray[step] as any;
  const [completed] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  function isLastStep() {
    return step === childrenArray.length - 1;
  }

  async function submitHandler(values: any, helpers: any) {
    const lastStep = childrenArray.length - 1;

    switch (step) {
      case lastStep:
        helpers.setSubmitting(true);
        onSubmit(values, { setSubmitting: helpers.setSubmitting });
        break;
      case 0:
        const result = await dispatch(
          ApiSlice.endpoints.create.initiate({
            resource: `fixity/customer/customer/validateCustomerFromKpsService`,
            params: {
              identityNo: values.contact.identityNo,
              name: values.contact.name,
              surname: values.contact.surname,
              birthDate: values.contact.dateOfBirth,
            },
          })
        );
        const { data: validateKpsService }: any = result;

        if (validateKpsService) {
          setStep((step) => step + 1);
          return true;
        } else if (!validateKpsService && values.isExistCustomer) {
          setStep((step) => step + 1);
          return true;
        } else {
          Swal.fire("Hata!", "Tckn doğrulaması başarısız!", "error");
          return false;
        }
        break;
      default:
        helpers.setSubmitting(true);
        setStep((step) => step + 1);
        helpers.setSubmitting(false);
        break;
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      validationSchema={currentChild.props.validationSchema}
    >
      {({ isSubmitting }) => (
        <Form autoComplete="off">
          <HeaderStepper
            steps={childrenArray}
            activeStep={step}
            completed={completed}
          />
          {currentChild}
          <FormFooter>
            <Grid container spacing={3} justifyContent="center">
              {isSubmitting ? (
                <IsSubmittingButton />
              ) : (
                <>
                  {step > 0 && (
                    <Grid item>
                      <Button
                        disabled={isSubmitting}
                        color="primary"
                        className="btn btn-default"
                        onClick={() => setStep((step) => step - 1)}
                        style={{ minWidth: "200px" }}
                      >
                        {translate("actions.back")}
                      </Button>
                    </Grid>
                  )}

                  <Grid item>
                    <StepButton
                      isSubmitting={isSubmitting}
                      isLastStep={isLastStep()}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </FormFooter>
        </Form>
      )}
    </Formik>
  );
};

export default Stepper;
